
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 55 55","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"55","height":"55","rx":"5","fill":"#334C87"}}),_c('path',{attrs:{"d":"M33.499 27.552h-4.262V41h-5.372V27.552H21v-5.517h2.507V19.69c0-2.207 1.146-5.69 5.98-5.69h4.406v4.586h-3.116c-.502 0-1.182.31-1.182 1.38v2.069H34l-.501 5.517z","fill":"#fff"}})])
          )
        }
      }
    